<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
  <div class="fullContent">
    <div class="containerContent scrollList">
      <v-row>
        <v-col cols="12" class="mb-0 pb-0">
          <Header :countryDisplay="countryDisplay"></Header>
        </v-col>
      </v-row>
      <v-row style="height: calc(100% - 70px);">
        <v-col cols="12" lg="3">
          <Overview ref="Overview" @filterCountry="filterCountry"></Overview>
        </v-col>
        <v-col cols="12" lg="9">
          <v-row v-bind:style="{ 'min-height': $vuetify.breakpoint.mdAndDown? '': '50%', 'height': 'fit-content' }">
            <v-col cols="12" lg="7" class="pa-0" v-bind:style="{ 'min-height': $vuetify.breakpoint.mdAndDown? '500px !important': 'inherit' }">
              <Map ref="Map"></Map>
            </v-col>
            <v-col cols="12" lg="5" class="pt-0 pb-0" v-bind:style="{ 'margin-top': $vuetify.breakpoint.mdAndDown? '20px !important': 'inherit', 'height': $vuetify.breakpoint.mdAndDown? 'fit-content': '' }">
              <List ref="List" @resize="resize" @getHospitals="getHospitalsByCountry"></List>
            </v-col>
          </v-row>
          <v-row v-bind:style="{ 'min-height': $vuetify.breakpoint.mdAndDown? '': '50%', 'height': 'fit-content' }">
            <v-col cols="12" lg="7" class="pa-0 pt-3" v-bind:style="{ 'margin-top': $vuetify.breakpoint.mdAndDown? '20px !important': 'inherit', 'height': $vuetify.breakpoint.mdAndDown? 'fit-content': '' }">
              <Graph ref="Graph" @resize="resize"></Graph>
            </v-col>
            <v-col cols="12" lg="5" class="pb-0 pt-3" v-bind:style="{ 'margin-top': $vuetify.breakpoint.mdAndDown? '20px !important': 'inherit', 'height': $vuetify.breakpoint.mdAndDown? 'fit-content': '' }">
              <Alerts ref="Alerts"></Alerts>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Papa from 'papaparse'
import Header from "@/components/africa/Header"
import Overview from "@/components/africa/Overview"
import Map from "@/components/africa/Map"
import List from "@/components/africa/List"
import Graph from "@/components/africa/Graph"
import Alerts from "@/components/africa/Alerts"

export default {
  name: "AfricaDashboard",
  data: () => ({
    countryDisplay: "",
    allData: [],
    lastDate: ""
  }),
  components: {
    Header,
    Overview,
    Map,
    List,
    Graph,
    Alerts
  },
  mounted () {
    //post the GA
    gtag('event', 'page_view', {
      'send_to': 'UA-161523063-2'
    })
  },
  created() {
    //get the data and pass to child components
    this.loadData()
  },
  methods: {
    loadData() {
      var self = this

      //first load the continents
      self.loadContinents()
      .then(continents => {

          //then load the cases
          self.loadCases()
          .then(cases => {

            //then load the recoveries
            self.loadRecovered()
            .then(recovered => {
              
              //then load the populations
              self.loadPopulation()
              .then(populations => {

                  //then load the last updated date
                  self.loadLastUpdated()
                  .then(lastupdated => {

                    //then load testing 
                    self.loadTesting()
                    .then(testing => {
                        //done loading data so extract only Africa data
                  
                        //first get a list of all the countries
                        var countries = continents.filter(cont => cont.Continent === "Africa")
                        
                        //loop through each country to find the associated data
                        for (var i = 0; i < countries.length; i++) {

                          //cases
                          //NOTE: anything after the last updated date is removed because the dataset is updated in parts not all at once so it's skewing the stats
                          //NOTE: dates can be compared as a string because they are in the format YYYY-MM-DD

                          //last date
                          var lastDate = lastupdated[0][0]
                          self.lastDate = lastDate

                          var casesMatch = cases
                          .filter(c => c["Country"] === countries[i].Country_WHO && c.Date_reported <= lastDate)
                          .map(function(obj) {
                            return { 
                              date: obj.Date_reported, 
                              cumulative_cases: obj["Cumulative_cases"]*1, 
                              cumulative_deaths: obj["Cumulative_deaths"]*1, 
                              new_cases: obj["New_cases"]*1, 
                              new_deaths: obj["New_deaths"]*1
                            };
                          })

                          //check error matching country to cases
                          if(casesMatch.length === 0) {
                            console.error("CASES NOT FOUND", countries[i].Country_WHO)
                          }
                                        

                          //recovered
                          var headers = recovered[0]  //the first row is the headers
                          var recoveredMatch = recovered.find(r => r[1] === countries[i].Country)

                          //for each of the cases days for this country find it's recovered number
                          for (var j = 0; j < casesMatch.length; j++) {
                            //reformat the 2 dates to be the same
                            //cases is 2020-06-28, recovered is 6/28/20

                            var cdate = this.$moment(casesMatch[j].date, "YYYY-MM-DD")
                            //subtract one day because JH is ahead in reporting compared to WHO
                            cdate = cdate.subtract(1, "days")
                            var fDate = cdate.format('M/D/YY')

                            var index = headers.indexOf(fDate)
                            if(index !== -1) {
                              //found
                              casesMatch[j].cumulative_recovered = recoveredMatch[index]*1
                            }
                            else {
                              //console.error("RECOVERED NOT FOUND", countries[i].Country_WHO, casesMatch[j].date)

                              //set it to 0
                              casesMatch[j].cumulative_recovered = 0
                            }
                          }

                          //population data
                          var populationMatch = populations.find(p => p.location === countries[i].Country_OWID)
                          if(!populationMatch) {
                            console.error("POPULATION NOT FOUND", countries[i].Country_OWID)
                          }

                          //testing data
                          var ctests = testing.filter(t => t["ISO code"] === populationMatch.iso_code)

                          //add to the country's data
                          countries[i].cases = casesMatch
                          countries[i].lat = recoveredMatch[2]
                          countries[i].lng = recoveredMatch[3]
                          countries[i].population = populationMatch
                          countries[i].tests = ctests
                        }

                        //store all the data for filtering later on
                        self.allData = countries

                        //finished load the data so load the components
                        self.$refs.Overview.loadCountriesList(countries)
                        self.$refs.Overview.loadCases(countries)
                        self.$refs.Map.loadCases(self.lastDate, countries)
                        self.$refs.List.loadCases(countries)
                        self.$refs.Graph.loadCases(countries)
                        self.$refs.Alerts.loadCases(self.lastDate, countries)

                    }).catch(err => {
                        console.error(err)
                    })

                  }).catch(err => {
                      console.error(err)
                  })

              }).catch(err => {
                  console.error(err)
              })

            }).catch(err => {
                console.error(err)
            })

          }).catch(err => {
              console.error(err)
          })

      }).catch(err => {
          console.error(err)
      })
    },
    loadLastUpdated() {
      var self = this

      return new Promise((resolve, reject) => {
          var d = new Date()
          var url = "data/africa/lastupdated.csv"
          url += "?etag=" + d.toISOString()

          Papa.parse(url, {
            download: true,
            header: false,
            skipEmptyLines: true,
            complete: function(results) {
              resolve(results.data)
            },
            error: function(err)
            {
              reject(err)
            }
          })
      })
    },
    loadContinents() {
      var self = this

      return new Promise((resolve, reject) => {
          var d = new Date()
          var url = "data/geo/continents.csv"
          url += "?etag=" + d.toISOString()

          Papa.parse(url, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function(results) {
              resolve(results.data)
            },
            error: function(err)
            {
              reject(err)
            }
          })
      })
    },
    loadCases() {
      var self = this

      return new Promise((resolve, reject) => {
          var d = new Date()
          var url = "data/africa/WHO-COVID-19-global-data.csv"
          url += "?etag=" + d.toISOString()

          Papa.parse(url, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function(results) {
              resolve(results.data)
            },
            error: function(err)
            {
              reject(err)
            }
          })
      })
    },
    loadRecovered() {
      var self = this

      return new Promise((resolve, reject) => {
          var d = new Date()
          var url = "data/africa/time_series_covid19_recovered_global.csv"
          url += "?etag=" + d.toISOString()

          Papa.parse(url, {
            download: true,
            //header: true,
            skipEmptyLines: true,
            complete: function(results) {
              resolve(results.data)
            },
            error: function(err)
            {
              reject(err)
            }
          })
      })
    },
    loadPopulation() {
      var self = this

      return new Promise((resolve, reject) => {
          var d = new Date()
          var url = "data/africa/population.csv"
          url += "?etag=" + d.toISOString()

          Papa.parse(url, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function(results) {
              resolve(results.data)
            },
            error: function(err)
            {
              reject(err)
            }
          })
      })
    },
    loadTesting() {
      var self = this

      return new Promise((resolve, reject) => {
          var d = new Date()
          var url = "data/africa/covid-testing-all-observations.csv"
          url += "?etag=" + d.toISOString()

          Papa.parse(url, {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: function(results) {
              resolve(results.data)
            },
            error: function(err)
            {
              reject(err)
            }
          })
      })
    },
    filterCountry(country) {

      var filteredData = []

      if (country !== "Africa") {
        this.countryDisplay = country
        filteredData = this.allData.filter(d => d.Country_WHO === country)

      } else {
        this.countryDisplay = ""
        filteredData = this.allData
      }

      //load the components
      this.$refs.Overview.loadCases(filteredData, this.countryDisplay)
      this.$refs.Map.loadCases(this.lastDate, filteredData, this.countryDisplay)
      this.$refs.List.loadCases(filteredData, this.countryDisplay)
      this.$refs.Graph.loadCases(filteredData, this.countryDisplay)
      this.$refs.Alerts.loadCases(this.lastDate, filteredData, this.countryDisplay)
    },
    resize() {
      this.$refs.Map.resize();
    },
    getHospitalsByCountry(country) {
      var hospitals = this.$refs.Map.getHospitalsByCountry(country)
      this.$refs.List.setHospitals(hospitals)
    }
  },
};
</script>

<style scoped>
.fullContent {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.containerContent {
  height: 100%;
  background: linear-gradient(
    to bottom left,
    #216e93,
    #21648a,
    #1f5881,
    #172d5b,
    #191c51
  );
  color: #fff;
}
</style>
